import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

const validDate = (value) => moment(value, 'YYYY-MM-DD', true).isValid() ? value : '';

export default function useExceptionsFilters() {
    const history = useHistory();
    const { pathname, search } = useLocation();
    const params = new URLSearchParams(search);
    const parsedRows = Number(params.get('rows'));
    const rowsPerPage = [20, 40, 60, 80, 100].includes(parsedRows) ? parsedRows : 20;
    const parsedPage = Number(params.get('page'));
    const page = Number.isSafeInteger(parsedPage) && parsedPage > 0 ? parsedPage : 1;
    const fromDate = validDate(params.get('from_date'));
    const toDate = validDate(params.get('to_date'));
    const searchTerm = (params.get('search') || '').slice(0, 200);
    const update = (values, replace = false) => {
        const next = new URLSearchParams(search);
        Object.entries(values).forEach(([key, value]) => {
            if (value === '' || value == null || (key === 'page' && Number(value) === 1)) next.delete(key);
            else next.set(key, String(value));
        });
        next.delete('first_page');
        const query = next.toString();
        history[replace ? 'replace' : 'push']({ pathname, search: query ? `?${query}` : '' });
    };
    return {
        page, rowsPerPage, fromDate, toDate, searchTerm,
        changePage: (value) => update({ page: value }),
        changeRowsPerPage: (value) => update({ rows: value, page: 1 }),
        changeSearch: (value) => update({ search: value.trim(), page: 1 }, true),
        changeFromDate: (value) => update({ from_date: value, to_date: toDate && value > toDate ? '' : toDate, page: 1 }),
        changeToDate: (value) => update({ to_date: value, from_date: fromDate && value && value < fromDate ? '' : fromDate, page: 1 }),
        changeDates: (from, to) => update({ from_date: from, to_date: to, page: 1 }),
        clearFilters: () => update({ search: '', from_date: '', to_date: '', page: 1 }),
    };
}
